"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _hotspot = require("../../hotspot.defaultConfigs");

var _BigPulse = require("./BigPulse.styles");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var BigPulse = function BigPulse(_ref) {
  var config = _ref.config,
      iconPosition = _ref.iconPosition,
      onClick = _ref.onClick,
      previewHoverState = _ref.previewHoverState,
      disableHover = _ref.disableHover,
      name = _ref.name;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var _ref2 = config || _hotspot.bigPulse,
      _ref2$primaryColor = _ref2.primaryColor,
      primaryColor = _ref2$primaryColor === void 0 ? '#E6E7E8' : _ref2$primaryColor,
      secondaryColor = _ref2.secondaryColor;

  var delays = [0, 300, 600];
  var ariaLabel = "".concat(name, " hotspot");
  return _react.default.createElement(_BigPulse.ClickableAreaStyled, {
    onClick: onClick,
    previewHoverState: previewHoverState,
    secondaryColor: secondaryColor || primaryColor,
    disableHover: disableHover,
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    "aria-label": ariaLabel
  }, _react.default.createElement(_BigPulse.ExpandingBoundingBoxStyled, null), iconPosition && _react.default.createElement(_BigPulse.BigPulseStyled, {
    iconPosition: iconPosition,
    secondaryColor: secondaryColor || primaryColor,
    hovered: hovered
  }, delays.map(function (delay) {
    return _react.default.createElement(_BigPulse.PulseStyled, {
      animation: "2s linear infinite",
      size: "10em",
      key: delay,
      className: "pulse",
      delay: delay,
      shadow: hovered ? secondaryColor || primaryColor : primaryColor,
      hovered: hovered
    });
  })));
};

var _default = BigPulse;
exports.default = _default;